export default __webpack_public_path__ + "static/media/invoice-sent.5f8f5c13.svg";